export enum BuilderAgentTools {
  SetMapCenterAndZoomV1 = 'set_map_center_and_zoom_v1_0_0',
  SetMapCenterAndZoomToLayerV1 = 'set_map_center_and_zoom_to_layer_v1_0_0',
  GetFormulaWidgetV1 = 'get_formula_widget_v1_0_0',
  GetCategoryWidgetV1 = 'get_category_widget_v1_0_0',
  GetHistogramWidgetV1 = 'get_histogram_widget_v1_0_0',
  GetTimeSeriesWidgetV1 = 'get_time_series_widget_v1_0_0',
  FilterCategoryWidgetV1 = 'filter_category_widget_v1_0_0',
  FilterHistogramWidgetV1 = 'filter_histogram_widget_v1_0_0',
  FilterRangeWidgetV1 = 'filter_range_widget_v1_0_0',
  SetLayersVisibilityV1 = 'set_layers_visibility_v1_0_0',
  GetMapCoordinatesV1 = 'get_map_coordinates_v1_0_0',
  GetSpatialFilterV1 = 'get_spatial_filter_v1_0_0',
  SetSpatialFilterV1 = 'set_spatial_filter_v1_0_0',
  SetSqlParameterTextV1 = 'set_sql_parameter_text_v1_0_0',
  SetSqlParameterDateRangeV1 = 'set_sql_parameter_date_range_v1_0_0',
  SetSqlParameterNumericV1 = 'set_sql_parameter_numeric_v1_0_0',
  SetSqlParameterNumericRangeV1 = 'set_sql_parameter_numeric_range_v1_0_0',
  AddSourceV1 = 'add_source_v1_0_0',
  RemoveSourceV1 = 'remove_source_v1_0_0',
  AddLayerV1 = 'add_layer_v1_0_0',
  RemoveLayerV1 = 'remove_layer_v1_0_0',
  SetLayerStyleV1 = 'set_layer_style_v1_0_0',
  AddMarkerV1 = 'add_marker_v1_0_0',
  AsyncWorkflowJobCheckResultsV1 = 'async_workflow_job_check_results_v1_0_0',
  AddSourceFromWorkflowsV1 = 'add_source_from_workflows_v1_0_0'
}
